module.exports = __webpack_public_path__ + "static/media/logo-inner.02888b4f.svg";